<template>
    <div class="form-group">
        <label class="form-check-label mb-1">Pharmacy</label>
        <TypeaheadInput
            :getData="getPharmacyList"
            :value="pharmacy"
            placeholder="Start Typing..."
            v-on:valueChanged="pharmacyChanged"
        ></TypeaheadInput>
        <div class="ms-3 mt-3 card card-body p-3" v-if="loadingPharmacyDetails">
            <p>
                <span class="shimmer-loading block-size-6"></span>
            </p>
            <p>
                <span class="shimmer-loading block-size-4"></span>
            </p>
            <p>
                <span class="shimmer-loading block-size-8"></span>
            </p>
            <p>
                <span class="shimmer-loading block-size-6"></span>
            </p>
            <p>
                <span class="shimmer-loading block-size-4"></span>
            </p>
        </div>
        <div class="mt-2 card p-2 d-flex flex-column" v-if="!loadingPharmacyDetails && pharmacyDetails.Id">
            <h5 class="mb-2">{{ pharmacyDetails.Name }}</h5>
            <section class="d-flex mb-1">
                <FormatName
                    :first-name="pharmacyDetails.ContactFirstName"
                    :last-name="pharmacyDetails.ContactLastName"
                ></FormatName>
            </section>
            <section class="d-flex mb-1">
                <span class="me-1">{{ pharmacyDetails.Address.addressLine1 }},</span>
                <span class="me-1" v-if="pharmacyDetails.Address.addressLine2">
                    {{ pharmacyDetails.Address.addressLine2 }},
                </span>
                <span class="me-1">{{ pharmacyDetails.Address.city }},</span>
                <span class="me-1">{{ pharmacyDetails.Address.state }}</span>
                <span class="me-1">{{ formatZipCode(pharmacyDetails.Address.zipCode) }}</span>
            </section>
            <section class="d-flex mb-1" v-if="pharmacyDetails.PhoneNumbers">
                <span>
                    {{ formatPhoneNumber(pharmacyDetails.PhoneNumbers[0].number) }}
                    <template v-if="pharmacyDetails.PhoneNumbers[1] && pharmacyDetails.PhoneNumbers[1].number">
                        , {{ formatPhoneNumber(pharmacyDetails.PhoneNumbers[1].number) }}</template
                    >
                </span>
            </section>
            <section class="d-flex" v-if="pharmacyDetails.Email">
                <span> {{ pharmacyDetails.Email }} </span>
            </section>
        </div>
    </div>
</template>

<script lang="ts" src="./PatientPharmacy.ts"></script>
